/* HSE WISE Lighting Controls · sensor unit price + minimum order · v1 2026-10-22 · built from scratchpad/shop3/site.tpl.js (unitPrice) */
(function () {
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* Sensors are sold in packs of 5 (owner, 2026-10-22): wherever the theme prints a price for these products (grid
     cards, product page, sticky bar, search and menu cards) show the price per sensor and "Min. order 5" instead;
     checkout still charges the pack. Products: ids and handles below. */
  var PACK = { ids: { '9370785022174': 5, '9370785087710': 5, '9370785153246': 5 },
               handles: { 'hse-sp5l-2': 5, 'hse-sp5l-2a': 5, 'hd07vr': 5 } };
  function packOf(box) {
    var host = box.closest('[data-product-id]');
    if (host) return PACK.ids[host.getAttribute('data-product-id')] || 0;
    var ev = box.closest('[view-event-payload]');
    if (ev) { try { return PACK.ids[String(JSON.parse(ev.getAttribute('view-event-payload')).product.id)] || 0; } catch (e) {} }
    var card = box.closest('product-card, .resource-card, .product-grid__item, li');
    var a = card && card.querySelector('a[href*="/products/"]');
    if (a) { var h = (a.getAttribute('href').split('/products/')[1] || '').split(/[?#/]/)[0]; if (PACK.handles[h]) return PACK.handles[h]; }
    return 0;
  }
  function money(n) { return '$' + n.toFixed(2); }
  function unitOne(box) {
    var n = packOf(box); if (!n) return;
    var pr = box.querySelector('.price:not(.hse-u)'); if (!pr) return;
    var txt = pr.textContent.trim(), v = parseFloat(txt.replace(/[^0-9.]/g, ''));
    if (!v || (box.getAttribute('data-hse-unit') === txt && box.querySelector('.hse-unit'))) return;
    box.setAttribute('data-hse-unit', txt);
    var old = box.querySelector('.hse-unit'); if (old) old.parentNode.removeChild(old);
    var compact = !!box.closest('.sticky-add-to-cart, .resource-card');
    var w = document.createElement('span');
    w.className = 'hse-unit' + (compact ? ' hse-unit--c' : '');
    w.innerHTML = '<span class="hse-unit__p"><span class="price hse-u">' + money(v / n) + '</span><span class="hse-unit__per">/ unit</span></span>' +
      '<span class="hse-unit__moq">' + (compact ? 'Min. order ' + n : 'Min. order ' + n + ' · ' + esc(txt) + ' per pack of ' + n) + '</span>';
    box.classList.add('hse-has-unit');
    box.appendChild(w);
  }
  function unitPrice() {
    var t = 0;
    function run() { Array.prototype.forEach.call(document.querySelectorAll('[ref="priceContainer"], .sticky-add-to-cart__price'), unitOne); }
    run();
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 60); })
      .observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function boot() {
    var st = document.createElement('style'); st.textContent = "/* sensors: price per unit + minimum order (packs of 5) */\n.hse-has-unit .price:not(.hse-u){display:none!important}\n.hse-unit{display:flex;flex-direction:column;gap:2px}\n.hse-unit__p{display:inline-flex;align-items:baseline;gap:5px;flex-wrap:wrap}\n.hse-unit__per{font-size:.62em;font-weight:500;opacity:.7;letter-spacing:0}\n.hse-unit__moq{display:inline-block;align-self:flex-start;font-size:12.5px;line-height:1.35;font-weight:600;letter-spacing:.01em;color:#003996;background:#eaf1ff;border-radius:4px;padding:3px 8px;margin-top:4px}\n.hse-unit--c{flex-direction:row;align-items:baseline;gap:8px;flex-wrap:wrap}\n.hse-unit--c .hse-unit__moq{margin-top:0;font-size:11.5px;padding:2px 6px}";
    document.head.appendChild(st);
    try { unitPrice(); } catch (e) { if (window.console) console.warn('hse unit price', e); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
